import { ComponentType, lazy as _lazy } from 'react';

function lazy<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
) {
  return _lazy(async () => {
    const m = await importFn();
    return { default: m.default };
  });
}

export const icons = {
  AccountStatement: lazy(
    async () => import('./svg/account-statement.svg?react'),
  ),
  AddFile: lazy(async () => import('./svg/add-file.svg?react')),
  AddImage: lazy(async () => import('./svg/add-image.svg?react')),
  AddUsers: lazy(async () => import('./svg/add-users.svg?react')),
  Alert: lazy(async () => import('./svg/alert.svg?react')),
  Arobase: lazy(async () => import('./svg/arobase.svg?react')),
  ArrowDown: lazy(async () => import('./svg/arrow-down.svg?react')),
  ArrowLeft: lazy(async () => import('./svg/arrow-left.svg?react')),
  ArrowRight: lazy(async () => import('./svg/arrow-right.svg?react')),
  ArrowUp: lazy(async () => import('./svg/arrow-up.svg?react')),
  AverageDelay: lazy(async () => import('./svg/average-delay.svg?react')),
  Ban: lazy(async () => import('./svg/ban.svg?react')),
  Bell: lazy(async () => import('./svg/bell.svg?react')),
  Bin: lazy(async () => import('./svg/bin.svg?react')),
  BlockedCase: lazy(async () => import('./svg/blocked-case.svg?react')),
  Building: lazy(async () => import('./svg/building-regular-full.svg?react')),
  Calendar: lazy(async () => import('./svg/calendar.svg?react')),
  CalendarDays: lazy(
    async () => import('./svg/calendar-days-solid-full.svg?react'),
  ),
  CaseBanTop: lazy(async () => import('./svg/case_ban_top.svg?react')),
  CaseCheck: lazy(async () => import('./svg/case_check.svg?react')),
  CaseCheckTop: lazy(async () => import('./svg/case_check_top.svg?react')),
  CaseNext: lazy(async () => import('./svg/case_next.svg?react')),
  CaseUser: lazy(async () => import('./svg/case_user.svg?react')),
  Chat: lazy(async () => import('./svg/chat.svg?react')),
  ChatEuro: lazy(async () => import('./svg/chat-euro.svg?react')),
  Check: lazy(async () => import('./svg/check.svg?react')),
  Cheese: lazy(async () => import('./svg/cheese.svg?react')),
  CheeseColored: lazy(async () => import('./svg/cheese_colored.svg?react')),
  ChevronDown: lazy(async () => import('./svg/chevron-down.svg?react')),
  ChevronLeft: lazy(async () => import('./svg/chevron-left.svg?react')),
  ChevronRight: lazy(async () => import('./svg/chevron-right.svg?react')),
  ChevronUp: lazy(async () => import('./svg/chevron-up.svg?react')),
  CircleCross: lazy(async () => import('./svg/circle_cross.svg?react')),
  Clock: lazy(async () => import('./svg/clock.svg?react')),
  CreditCard: lazy(
    async () => import('./svg/credit-card-regular-full.svg?react'),
  ),
  Cross: lazy(async () => import('./svg/cross.svg?react')),
  Crown: lazy(async () => import('./svg/crown-solid-full.svg?react')),
  DataIntegration: lazy(async () => import('./svg/data-integration.svg?react')),
  DisableCheckbox: lazy(async () => import('./svg/disable-checkbox.svg?react')),
  Dots: lazy(async () => import('./svg/dots.svg?react')),
  Download: lazy(async () => import('./svg/download.svg?react')),
  DownloadCase: lazy(async () => import('./svg/download_case.svg?react')),
  DownloadSquare: lazy(async () => import('./svg/download_square.svg?react')),
  EditUser: lazy(async () => import('./svg/edit-user.svg?react')),
  Euro: lazy(async () => import('./svg/euro.svg?react')),
  Eye: lazy(async () => import('./svg/eye.svg?react')),
  EyeClosed: lazy(async () => import('./svg/eye_closed.svg?react')),
  EyeInvoice: lazy(async () => import('./svg/eye_invoice.svg?react')),
  Filter: lazy(async () => import('./svg/filter.svg?react')),
  FilterOff: lazy(async () => import('./svg/filter-off.svg?react')),
  Flash: lazy(async () => import('./svg/flash.svg?react')),
  Gift: lazy(async () => import('./svg/gift-solid-full.svg?react')),
  Headset: lazy(async () => import('./svg/headset.svg?react')),
  Hide: lazy(async () => import('./svg/hide.svg?react')),
  Home: lazy(async () => import('./svg/home.svg?react')),
  Information: lazy(async () => import('./svg/information.svg?react')),
  Invoice: lazy(async () => import('./svg/invoice.svg?react')),
  InvoiceFilled: lazy(async () => import('./svg/invoice_filled.svg?react')),
  LanguageSolidFull: lazy(
    async () => import('./svg/language-solid-full.svg?react'),
  ),
  Letter: lazy(async () => import('./svg/letter.svg?react')),
  LetterSearch: lazy(async () => import('./svg/letter_search.svg?react')),
  LetterSent: lazy(async () => import('./svg/letter_sent.svg?react')),
  Libra: lazy(async () => import('./svg/libra.svg?react')),
  Link: lazy(async () => import('./svg/link.svg?react')),
  LoadData: lazy(async () => import('./svg/load-data.svg?react')),
  Loader: lazy(async () => import('./svg/loader.svg?react')),
  LoadYourData: lazy(async () => import('./svg/load-your-data.svg?react')),
  Lock: lazy(async () => import('./svg/lock.svg?react')),
  Message: lazy(async () => import('./svg/message.svg?react')),
  OpenLetter: lazy(async () => import('./svg/open-letter.svg?react')),
  Paperclip: lazy(async () => import('./svg/paperclip.svg?react')),
  Pen: lazy(async () => import('./svg/pen.svg?react')),
  PenFilled: lazy(async () => import('./svg/pen_filled.svg?react')),
  Phone: lazy(async () => import('./svg/phone.svg?react')),
  PhoneFilled: lazy(async () => import('./svg/phone_filled.svg?react')),
  PlusSm: lazy(async () => import('./svg/plus-sm.svg?react')),
  Print: lazy(async () => import('./svg/print.svg?react')),
  Relance: lazy(async () => import('./svg/relance.svg?react')),
  Rocket: lazy(async () => import('./svg/rocket.svg?react')),
  Search: lazy(async () => import('./svg/search.svg?react')),
  Send: lazy(async () => import('./svg/send.svg?react')),
  SendMessage: lazy(async () => import('./svg/send-message.svg?react')),
  Settings: lazy(async () => import('./svg/settings.svg?react')),
  SingleMessage: lazy(async () => import('./svg/single-message.svg?react')),
  Share: lazy(async () => import('./svg/share.svg?react')),
  Shield: lazy(async () => import('./svg/shield.svg?react')),
  Show: lazy(async () => import('./svg/show.svg?react')),
  Sparkles: lazy(async () => import('./svg/sparkles.svg?react')),
  SparklesFilled: lazy(async () => import('./svg/sparkles_filled.svg?react')),
  SquareChecked: lazy(async () => import('./svg/square-checked.svg?react')),
  UserBorder: lazy(async () => import('./svg/user_border.svg?react')),
  UserFull: lazy(async () => import('./svg/user_full.svg?react')),
  UserPlus: lazy(async () => import('./svg/user-plus.svg?react')),
  UserProfile: lazy(async () => import('./svg/user-profile.svg?react')),
  Users: lazy(async () => import('./svg/users.svg?react')),
  UserSquare: lazy(async () => import('./svg/user_square.svg?react')),
  Validation: lazy(async () => import('./svg/validation.svg?react')),
  Verified: lazy(async () => import('./svg/verified.svg?react')),
  Warning: lazy(async () => import('./svg/warning.svg?react')),
};
